var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6364 11.3182C20.6364 18.9545 10.8182 25.5 10.8182 25.5C10.8182 25.5 1 18.9545 1 11.3182C1 8.71424 2.03441 6.21695 3.87568 4.37568C5.71694 2.53441 8.21424 1.5 10.8182 1.5C13.4221 1.5 15.9194 2.53441 17.7607 4.37568C19.6019 6.21695 20.6364 8.71424 20.6364 11.3182Z",
    stroke: "#22495F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.822 14.5918C12.6295 14.5918 14.0948 13.1266 14.0948 11.3191C14.0948 9.51164 12.6295 8.04639 10.822 8.04639C9.01457 8.04639 7.54932 9.51164 7.54932 11.3191C7.54932 13.1266 9.01457 14.5918 10.822 14.5918Z",
    stroke: "#22495F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventLocationIcon);
export default __webpack_public_path__ + "static/media/event-location-icon.62ec96d03e1ee55a4091df143a60e22a.svg";
export { ForwardRef as ReactComponent };